var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes.concat( [{'amount-negative': _vm.isNegative, 'amount': true}])},[_vm._v("\n  "+_vm._s(_vm.formatCurrency(_vm.value))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }